<template>
    <v-container class="inner-main pt-2 mb-10">
        <v-row class="mx-0">
            <h2>{{ $t('global.menu.backoffice.attribute') }}</h2>
        </v-row>
        <v-row class="mb-3">
            <v-data-table-server v-model:items-per-page="itemsPerPage" :items-per-page-options="pageOptions"
                density="compact" :headers="headers" :items="serverItems" :items-length="totalItems" :loading="loading"
                :search="search" item-value="name" @update:options="loadItems" @update:page="updatePage" height="60vh"
                :update:sortBy="updateSortBy" :mobile="['xs', 'sm', 'md'].includes($globalState.screenWidth)"
                class="shop-list-table" fixed-header>
                <template v-slot:top>
                    <v-row>
                        <v-col>
                            <!-- TODO BACKEND SEARCH FUNCTION PAGINATION -->
                            <!-- BACKEND PAGINATION VOUCHER -->
                            <v-text-field v-model="search" :disabled="false"
                                :placeholder="$t('main.search.placeholder')" variant="outlined" hide-details="true"
                                density="compact" class="pb-2 py-0 bg-white" height="32px">
                                <template v-slot:append-inner>
                                    <v-icon icon="mdi-magnify"></v-icon>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="4" class="text-right">
                            <v-btn color="primary" variant="flat" class="mr-1" rounded="xl" size="large"
                                @click="() => createNewAttribute()">
                                {{ $t('global.menu.backoffice.createAttribute') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </template>

                <template v-slot:[`item.nameTranslations`]="{ value }">
                    {{ value[selectedLanguage.toUpperCase()] }}
                </template>
                <template v-slot:[`item.descriptionTranslations`]="{ value }">
                    {{ value[selectedLanguage.toUpperCase()] }}
                </template>
                <template v-slot:[`item.controls`]="props">
                    <v-btn color="primary" variant="flat" size="32" class="mr-1"
                        @click="() => editAttribute(props.item)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn color="error" variant="flat" size="32" class="mr-1"
                        @click="() => removeAttribute(props.item)">
                        <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                </template>

            </v-data-table-server>
        </v-row>
        <CreateAttributeDialog v-model="showDialog" v-model:data="newAttribute" :save="saveAttribute">
        </CreateAttributeDialog>
        <CustomConfirmDeletionDialog v-model="showDeleteDialog" v-model:data="removedAttribute"
            :confirm-deletion="deleteAttribute">
        </CustomConfirmDeletionDialog>
    </v-container>
</template>

<script>
import { ref, inject, getCurrentInstance, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import CreateAttributeDialog from './modals/CreateAttributeDialog.vue';
import CustomConfirmDeletionDialog from './modals/CustomConfirmDeletionDialog.vue';

export default {
    components: {
        CreateAttributeDialog,
        CustomConfirmDeletionDialog
    },
    setup() {

        const { proxy } = getCurrentInstance();
        const router = useRouter();
        const selectedLanguage = localStorage.getItem('selectedLanguage');
        const { t, locale } = useI18n();
        const newAttribute = ref({})
        const removedAttribute = ref({})
        const showDialog = ref(false)
        const showDeleteDialog = ref(false)
        const softToken = localStorage.getItem("softToken");
        const hardToken = localStorage.getItem("hardToken");
        const username = localStorage.getItem("username");

        const createNewAttribute = () => {
            newAttribute.value = { nameTranslations: {} }
            showDialog.value = true;
        }

        const updateSortBy = (newSort) => {
            proxy.sortBy = newSort;
        }

        const editAttribute = (item) => {
            newAttribute.value = item
            showDialog.value = true;
        }

        const saveAttribute = async () => {
            if (newAttribute.value.id) {

                const { areas, ...copy } = newAttribute.value;

                // PUT /backoffice/attributes/fccee441-6591-42d1-8c4e-bd3112dfa7f4
                try {
                    const response = await proxy.$axios.put(`/backoffice/attributes/${newAttribute.value.id}`, copy, {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    });
                    if (response.data.status == "OK") {
                        showDialog.value = false;
                        proxy.loadItems({ page: proxy.page, itemsPerPage: proxy.itemsPerPage, sortBy:proxy.sortBy })
                    }

                } catch (error) {
                    console.error("Error fetching search results:", error);
                }

            } else {
                if (typeof newAttribute.value.vouchersAvailable == 'undefined') {
                    newAttribute.value.vouchersAvailable = false;
                }
                newAttribute.value.fairlingTarget = false;
                newAttribute.value.activeInFindeling = false;

                const { areas, ...copy } = newAttribute.value;
                try {
                    const response = await proxy.$axios.post(`/backoffice/attributes`, copy, {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    });

                    if (response.data.status == "OK") {
                        showDialog.value = false;
                        proxy.loadItems({ page: proxy.page, itemsPerPage: proxy.itemsPerPage, sortBy:proxy.sortBy })
                    }

                } catch (error) {
                    console.error("Error fetching search results:", error);
                }
            }
        }
        const removeAttribute = (item) => {
            removedAttribute.value = item;
            showDeleteDialog.value = true;
        }

        const deleteAttribute = async (item) => {
            try {
                const response = await proxy.$axios.delete(`/backoffice/attributes/${item.id}`, {
                    headers: {
                        'X-Auth-HARDTOKEN': hardToken,
                        'X-Auth-SOFTTOKEN': softToken,
                        'X-Auth-USER': username
                    },
                });

                if (response.data.status == "OK") {
                    showDeleteDialog.value = false;
                    proxy.loadItems({ page: proxy.page, itemsPerPage: proxy.itemsPerPage, sortBy:proxy.sortBy });
                }
            } catch (error) {
                console.error("Error fetching search results:", error);
            }
        }

        const updatePage = (newPage) => {
            proxy.page = newPage;
        }

        return {
            selectedLanguage,
            updatePage,
            newAttribute,
            removedAttribute,
            showDialog,
            showDeleteDialog,
            createNewAttribute,
            editAttribute,
            saveAttribute,
            removeAttribute,
            deleteAttribute,
            updateSortBy
        };
    },

    watch: {

    },

    data: () => ({
        page: 1,
        itemsPerPage: 50,
        sortBy: [],
        pageOptions: [
            { value: 50, title: '50' },
            { value: 100, title: '100' },
            { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
        ],
        headers: [
            { title: 'Name', key: 'nameTranslations', align: 'start', maxWidth: "200px" },
            { title: 'Description', key: 'descriptionTranslations', align: 'start', maxWidth: "200px", sortable: false },
            { title: 'FrontendId', key: 'frontendId', align: 'start', maxWidth: "50px" },
            { title: 'Order', key: 'order', align: 'start', maxWidth: "50px", sortable: false },
            { title: 'Actions', value: "controls", align: 'end', sortable: false },
        ],
        search: '',
        serverItems: [],
        loading: true,
        totalItems: 0,
    }),

    computed: {
    },

    mounted() {
    },

    methods: {
        loadItems({ page, itemsPerPage, sortBy }) {
            this.loading = true
            console.log(this.search)
            const hardToken = localStorage.getItem("hardToken");
            const username = localStorage.getItem("username");
            this.$axios.get(this.search.length >= 1 ? "/backoffice/attributes/query" : "/backoffice/v2/attributes", {
                headers: {
                    'X-Auth-HARDTOKEN': hardToken,
                    'X-Auth-USER': username
                },
                params: {
                    sortColumn: sortBy[0]?.key,
                    sortDirection: sortBy[0]?.order.toUpperCase(),
                    ...(this.search.length >= 1 ? { lang: this.selectedLanguage.toUpperCase(), search: this.search, resultsPerPage: itemsPerPage, page: page - 1 } : { lang: this.selectedLanguage.toUpperCase(), page: page - 1, resultsPerPage: itemsPerPage })
                }
            })
                .then(this.itemsFetched)
                .catch(error => {
                    console.error("Error fetching user data:", error);
                    // You can handle specific error codes here, for example, a 401 Unauthorized
                    if (error.response && error.response.status === 401 || error.response.status === 403) {
                        // Handle token expiration or unauthorized error
                        console.log("Session expired or unauthorized. Please log in again.");
                        // Optionally log the user out or redirect to login page
                    }
                });
        },
        itemsFetched(response) {
            console.log(response)
            this.serverItems = response.data.data;
            this.totalItems = response.data.totalElements
            this.loading = false
        }
    },
}
</script>

<style scoped>
.inner-main {
    margin-left: auto;
    margin-right: auto;
    max-width: 1170px;
    margin-top: 40px;
}
</style>

<style></style>

<style></style>